import { composeClassNames } from "@faedev/editor-utils";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { Alert } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import ListHeader from "src/components/ListHeader";
import Page from "src/components/Page";
import Preloader from "src/components/Preloader";
import Translate from "src/components/Translate";
import VideoList from "src/components/VideoList";
import constants from "src/constants";
import getDefaultOg from "src/functions/getDefaultOg";
import getSelectedFilters from "src/functions/getSelectedFilters";
import getSortOptions from "src/functions/getSortOptions";
import { mapContentToVideoCards } from "src/functions/mapContentToVideoCards";
import { sPageClasses } from "src/styles/sPageClasses.module.scss";
import { useFilters } from "../functions/useFilters";
import useGetDataSeriesAndClasses, {
  getDataSeriesAndClasses,
} from "../functions/useGetDataSeriesAndClasses";

export default function Classes({ staticLectures, staticPrograms }) {
  var { locale: lang, query, push } = useRouter();
  var dSortOptions = getSortOptions(`videos`);
  var dSelectedFilters = getSelectedFilters(`videos`);

  // const filtersState = useComponentState<FiltersState>(defaultFilter);
  const filtersState = useFilters();
  const { loading, error, data } = useGetDataSeriesAndClasses(
    filtersState.value
  );
  const dClassesList = data?.lectures || staticLectures;
  const dSeriesList = data?.programs || staticPrograms;
  const numberOfItems = dClassesList.length + dSeriesList.length;

  return (
    <>
      <Headers data={getDefaultOg(lang)} />

      <Page className={composeClassNames([sPageClasses, "page-classes"])}>
        <Header />
        <Content fluid={`xxl`}>
          {constants.Show.navSort || constants.Show.navFilter ? (
            <ListHeader
              sortOptions={dSortOptions}
              filtersState={filtersState}
              numberOfItems={numberOfItems}
            />
          ) : (
            <div></div>
          )}
          {loading ? <Preloader /> : <div></div>}
          {error && !data ? (
            <Alert variant="danger">{String(error.message)}</Alert>
          ) : (
            <div></div>
          )}
          {dSeriesList && (
            <VideoList
              data={mapContentToVideoCards(dSeriesList)}
              type={`preview`}
              size={`lg`}
              title={<Translate tKey={`List of series`} />}
              showMore={false}
            />
          )}
          {dClassesList && (
            <VideoList
              data={mapContentToVideoCards(dClassesList)}
              type={`preview`}
              size={`nm`}
              title={<Translate tKey={`List of classes`} />}
              showMore={false}
            />
          )}
        </Content>
        <Footer />
      </Page>
    </>
  );
}

export const getStaticProps: GetStaticProps = async function () {
  const { lectures, programs } = await getDataSeriesAndClasses();

  return {
    props: {
      staticLectures: lectures,
      staticPrograms: programs,
    },
    revalidate: constants.RefreshIntervals.default,
  };
};
